<template>
    <div style="padding-top:30px;">
      <div v-if="!is_loaded">
        The data is loading ...
      </div>
      <div v-else>
          <div class="pta-investor-profile-head">
            <h1><br />{{ user.profile.company }}</h1>
            <!-- <img src="/images/logo_profile.svg" /> -->
            <ul class="mm-links">
              <li><a :href="'/fs2/'+id+'/pdf'" class="mm-link-pdf">PDF</a></li>
              <li><a :href="'/fs/'+id+'/doc'" class="mm-link-word">Word</a></li>
              <li><a target="_blank" :href="'/fs2/'+user.alias+'/share'" class="mm-link-share">Share</a></li>
            </ul>
          </div>
          <div class="pta-investor-profile" style="padding-top:40px;">
            <div class="pta-investor-profile-left">
              <div class="pta-investor-profile-box">
                <h3>About the Manager / Sponsor</h3>
                <div class="pta-investor-profile-box-content">
                  {{ user.profile.company_description?user.profile.company_description:'No general description available.' }}
                </div>
              </div>
              <div class="pta-investor-profile-box">
                <h3>Key Differentiators / Track Record Highlights</h3>
                <div class="pta-investor-profile-box-content" v-if="user.profile.track_record_1 || user.profile.track_record_2 || user.profile.track_record_3 || user.profile.track_record_4">
                  <ul>
                    <li v-if="user.profile.track_record_1">{{ user.profile.track_record_1 }}</li>
                    <li v-if="user.profile.track_record_2">{{ user.profile.track_record_2 }}</li>
                    <li v-if="user.profile.track_record_3">{{ user.profile.track_record_3 }}</li>
                    <li v-if="user.profile.track_record_4">{{ user.profile.track_record_4 }}</li>
                  </ul>
                </div>
                <div class="pta-investor-profile-box-content" v-else>
                  No information available.
                </div>
              </div>
              <div class="pta-investor-profile-box">
                <h3>About the Offering</h3>
                <div class="pta-investor-profile-box-content">
                  {{ user.profile.strategy?user.profile.strategy:'No information available.' }}
                </div>
              </div>
            </div>
            <div class="pta-investor-profile-right">
              <div class="pta-investor-profile-box">
                <h3>Key Terms</h3>
                <div class="pta-investor-profile-box-content">
                  <table cellpadding="0" cellspacing="0" width="100%">
                    <tr><td>Asset Class</td>
                      <td v-if="user.profile.fund_type && user.profile.fund_type.name">
                        {{ user.profile.fund_type.name }}
                      </td><td v-else>-</td></tr>
                    <tr><td>Target Returns</td><td>
                      IRR % {{ user.profile.irr }} percent IRR / Equity Multiple / MOIC (x) {{ user.profile.moic }}x (Cash-on-Cash)
                    </td></tr>
                    <tr><td>Structure and Vehicle Domiciliation</td><td>{{ user.profile.inv_struct }}</td></tr>
                    <tr><td>Geographical Focus</td><td class="pta-factsheet-box-content-list" v-if="user.profile.asset_countries.length"><span v-for="asset_country in user.profile.asset_countries">{{ asset_country.name }}</span></td><td v-else>-</td></tr>
                    <tr><td>Target Volume</td><td>{{ user.profile.total_capital?user.profile.total_capital+'m':'-' }}</td></tr>
                    <tr><td>Holding Period</td><td>{{ user.profile.holding_period?user.profile.holding_period+' year(s)':'-' }}</td></tr>
                    <tr><td>Minimum Commitment Size</td><td>{{ user.profile.ticket_size?user.profile.ticket_size+'m':'-' }}</td></tr>
                    <tr><td>Are we a member of any ESG associations?</td><td>{{ user.profile.esg }}</td></tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
</template>
<script>
    export default {
        components : {  },
        data() {
            return {
              id:this.$route.params.id,
              is_loaded: false,
              user:''
            };
        },
        mounted(){
            if(!helper.hasPermission('edit-user')){
                helper.notAccessibleMsg();
                this.$router.push('/account/users/general-partners');
            }
            this.fetchUserData();
        },
        methods: {
          fetchUserData(){
            axios.get('/api/user/'+this.id)
                .then(response => response.data)
                .then(response => {
                  this.user = response.user;
                  this.is_loaded = true;
                })
                .catch(error => {
                  helper.showDataErrorMsg(error);
                  this.$router.push('/account/users/general-partners');
                })
          },
        },

      filters: {
        moment(date) {
          return helper.formatDate(date);
        },
        momentDateTime(date) {
          return helper.formatDateTime(date).replace(" "," at ");
        }
      }
    }
</script>
<style>
.pta-factsheet:after{
  content:'';
  display:table;
  clear: both;
}
.pta-factsheet-right,
.pta-factsheet-left{
  width:50%;
  float:left;
}
.pta-factsheet-right{
  padding-left:25px;
}
.pta-factsheet-left{
  padding-right:25px;
}
.pta-factsheet-box{
  background: rgb(255, 255, 255);
  margin-bottom: 30px;
  border-radius: 10px;
}
.pta-factsheet-box h3{
  text-align:center;
  background: rgb(233, 248, 252);
  padding:10px 20px;
  font-weight:500;
  margin:0;
}
.pta-factsheet-box-content{
  padding: 30px;
  font-size:0.75em;
}
.pta-factsheet-box-content ul{
  margin-left:24px;
  margin-bottom:0;
  padding-left:0;
}
.pta-factsheet-box-content ul li{
  margin-bottom:5px;
}
.pta-factsheet-box-content ul li:last-child{
  margin-bottom:0px;
}
.pta-factsheet-box-content table tr td{
  padding:10px 0;
  border-bottom:1px solid #efefef;
  vertical-align: top;
}
.pta-factsheet-box-content table tr td:first-child{
  padding-right:20px;
}
.pta-factsheet-box-content table tr:last-child td{
  border-bottom:0px solid #efefef;
}
.pta-factsheet-box-content-list span:after{
  content:', ';
}
.pta-factsheet-box-content-list span:last-child:after{
  content:'';
}
</style>